import { SortDirection } from "Constants";
import type { SortInfo } from "SortProvider";
import { SortDirection as WtgSortDirection, type SortColumn } from "wtg-material-ui";

export function isVue2Build(): boolean {
  return true;
}

export function convertGlowSortInfosToWtgSortColumns(sortInfos?: SortInfo[]): SortColumn[] {
  return sortInfos
    ? sortInfos.map((sortInfo) => ({
        column: {
          field: sortInfo.column.field,
        },
        direction:
          sortInfo.direction === SortDirection.Descending ? WtgSortDirection.Descending : WtgSortDirection.Ascending,
      }))
    : [];
}

export function convertWtgSortColumnsToGlowSortInfos(sortColumns?: SortColumn[]): SortInfo[] {
  return sortColumns
    ? sortColumns.map((sortColumn) => ({
        column: {
          field: sortColumn.column.field,
        },
        direction:
          sortColumn.direction === WtgSortDirection.Descending ? SortDirection.Descending : SortDirection.Ascending,
      }))
    : [];
}

export function parseDataTableOptions(options: {
  page: number;
  itemsPerPage: number;
  sortBy: string[];
  sortDesc: boolean[];
}): {
  page: number;
  itemsPerPage: number;
  sortBy: string[];
  sortDesc: boolean[];
} {
  const { page, itemsPerPage, sortBy, sortDesc } = options;
  return { page, itemsPerPage, sortBy, sortDesc };
}

export function getItemsLengthPropertyName(): string {
  /*! SuppressStringValidation property name */
  return "serverItemsLength";
}
